export default __webpack_public_path__ + "static/media/SCIENCE_PHYSICS.0d7dbc22.svg";